import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=63613002"
import script from "./InviteUser.vue?vue&type=script&lang=js"
export * from "./InviteUser.vue?vue&type=script&lang=js"
import style0 from "./InviteUser.vue?vue&type=style&index=0&id=63613002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports